export const ALFRESCO_USER = process.env.VUE_APP_ALFRESCO_USERNAME;
export const ALFRESCO_SECRET = process.env.VUE_APP_ALFRESCO_SECRET;
export const ALFRESCO_FOLDER_RECURSO =
  process.env.VUE_APP_ALFRESCO_FOLDER_RECURSO;
export const ALFRESCO_FOLDER_NOTIFICAO_PENALIDADE =
  process.env.VUE_APP_ALFRESCO_FOLDER_NOTIFICAO_PENALIDADE;
export const ALFRESCO_SERVICE_API = process.env.VUE_APP_ALFRESCO_SERVICE;
export const API_URL_AUTH = process.env.VUE_APP_API_AUTH;
export const API_URL_SERVICE = process.env.VUE_APP_API_SERVICE;
export const BASE_PATH_APP = process.env.VUE_APP_BASE_PATH;
export const VERSION_APP = process.env.VUE_APP_VERSION;
export const ID_APP = process.env.VUE_APP_ID;
export const API_URL_CEP = process.env.VUE_APP_API_CEP;
export const VUE_APP_RECAPTCHA_KEY = process.env.VUE_APP_RECAPTCHA_KEY;
export const VUE_APP_REPORT_URL = process.env.VUE_APP_REPORT_URL;
export const VUE_APP_SIT_API_URL = process.env.VUE_APP_SIT_API_URL;
export const VUE_APP_SIT_WS_API_URL = process.env.VUE_APP_SIT_WS_API_URL;
export const VUE_APP_PDF_URL = process.env.VUE_APP_PDF_URL;
export const VUE_APP_NAME = process.env.VUE_APP_NAME;
export const VUE_APP_SIT_PEDIDOS_API_URL = process.env.VUE_APP_SIT_PEDIDOS_API_URL;
export const VUE_APP_WIKI_RENOVACAO_VEICULO_URL = process.env.VUE_APP_WIKI_RENOVACAO_VEICULO_URL;
export const VUE_APP_FINANCEIRO_API_URL = process.env.VUE_APP_FINANCEIRO_API_URL;
export const VUE_APP_SIE_PEDIDOS_API_URL = process.env.VUE_APP_SIE_PEDIDOS_API_URL;
export const VUE_APP_SIE_PEDIDOS_API_LOGIN_URL = process.env.VUE_APP_SIE_PEDIDOS_API_LOGIN_URL;
export const API_URL_FORGOT = process.env.VUE_APP_API_FORGOT;

export const API_DETRAN_URL_LOGIN = process.env.VUE_APP_DETRAN_LOGIN_URL;
export const API_DETRAN_URL = process.env.VUE_APP_DETRAN_URL;
export const API_DETRAN_LOGIN = process.env.VUE_APP_DETRAN_LOGIN;
export const API_DETRAN_SENHA = process.env.VUE_APP_DETRAN_SENHA;

export const VUE_APP_GESSAN_URL = process.env.VUE_APP_GESSAN_URL;

export const VUE_APP_API_AUTH_GESSAN_URL  = process.env.VUE_APP_API_AUTH_GESSAN_URL;
export const API_VAIVEM_ESTUDANTE_URL = process.env.VUE_APP_API_VAIVEM_ESTUDANTE_URL;
export const VAIVEM_ESTUDANTE_AMBIENTE = process.env.VUE_APP_VAIVEM_ESTUDANTE_AMBIENTE;
export const VAIVEM_ESTUDANTE_CNPJ_HEADER = process.env.VUE_APP_VAIVEM_ESTUDANTE_CNPJ;
export const VAIVEM_ESTUDANTE_TOKEN_HEADER = process.env.VUE_APP_VAIVEM_ESTUDANTE_TOKEN;

export const API_SPGC_URL = process.env.VUE_APP_SPGC_API_URL;
export const API_CPV_URL = process.env.VUE_APP_CPV_API_URL;
export const API_CPV_AUTH_URL = process.env.VUE_APP_CPV_AUTH_API_URL;


export const AUTOMACAO_URL = process.env.VUE_APP_AUTOMACAO_URL;
export const AUTOMACAO_AMBIENTE = process.env.VUE_APP_AUTOMACAO_AMBIENTE;
export const AUTOMACAO_HEADER_CNPJ = process.env.VUE_APP_AUTOMACAO_HEADER_CNPJ;
export const AUTOMACAO_HEADER_token = process.env.VUE_APP_AUTOMACAO_HEADER_TOKEN; 


export const VUE_APP_GRAPHQL_SPS_URL = process.env.VUE_APP_GRAPHQL_SPS_URL;

export const VUE_APP_PASSELIVRE_AUTH_TOKEN = process.env.VUE_APP_PASSELIVRE_AUTH_TOKEN;
